<template>
  <main class="sa-content">
      <div class="sa-card-large">
        <div class="sa-mob-header">
      <h5 class="sa-card-tit">Settings</h5>
      <button class="sa-btn-back sa-h-sm-up" @click="$router.go(-1)">
        <i class="icon-left-arrow"></i>
      </button>
    </div>
        <div class="sa-row sa-mble-tab sa-mob-cont">
          <div class="sa-co-xs24 sa-col-sm24 sa-col-md12 sa-col-lg10">
            <div class="sa-tabs sa-btn-tabs ">
                <a v-on:click="tabSelection='accountSet'" v-bind:class="[ tabSelection === 'accountSet' ? 'active' : '' ]">Account Settings<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
                <a v-if="userInfo && userInfo.e_type == 'S' && multi_slot ==false" v-on:click="tabSelection='consultationSet'" v-bind:class="[ tabSelection === 'consultationSet' ? 'active' : '' ]">Consultation Settings<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
                <a v-on:click="tabSelection='notification'" v-bind:class="[ tabSelection === 'notification' ? 'active' : '' ]">Notification<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
                <a v-on:click="tabSelection='multiSlots'" v-bind:class="[ tabSelection === 'multiSlots' ? 'active' : '' ]" v-if="multi_slot ==true">Consultation<i class="icon-right-arrow tab-icon sa-h-sm-up"></i></a>
            </div>
            <div class="sa-tab-cont" :tabSelection="tabSelection">
              <account-settings v-if="tabSelection === 'accountSet'" v-on:multislot='multislot'/>
              <consultation-settings v-if="tabSelection === 'consultationSet'" />
              <notifications v-if="tabSelection === 'notification'" />
              <multi-slots v-if="tabSelection === 'multiSlots'" />
            </div>
          </div>
        </div>
      </div>
  </main>
</template>
<script>
import AccountSettingsVue from '../../components/settings/AccountSettings.vue';
import consultationSettingsVue from '../../components/settings/consultationSettings.vue';
import NotificationsVue from '../../components/settings/Notifications.vue';
import MultiSlots from '../../components/settings/MultiSlots.vue'
export default {
  components: {
    'account-settings': AccountSettingsVue,
    'consultation-settings': consultationSettingsVue,
    'notifications': NotificationsVue,
    MultiSlots

  },
  data() {
    return {
      tabSelection: 'accountSet',
      userInfo: {},
      multi_slot:false,
    };
  },
  created() {
    let _self = this;
    _self.userInfo = JSON.parse(_self.$localStorage.get('userdata')) 
  },
  methods:{
    multislot(val){
     this.multi_slot = val
    
    }
  }
};
</script>
